import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/character";

export default function useCharacters({ q = null, franchiseId = null } = {}) {
  const url = React.useMemo(() => {
    if (q === null && franchiseId === null) {
      return null;
    }
    const searchParams = new URLSearchParams();
    if (q) {
      searchParams.set("q", q);
    }
    if (franchiseId !== null) {
      searchParams.set("franchise_id", franchiseId);
    }
    const qs = searchParams.toString();
    return `${baseEndpoint}/admin/list${qs ? `?${qs}` : ""}`;
  }, [q, franchiseId]);

  const { data, error, mutate } = useSWR(url, fetcher, {
    keepPreviousData: true,
  });

  const characters = React.useMemo(() => {
    if (!Array.isArray(data?.characters)) {
      return [];
    }
    return data.characters;
  }, [data]);

  return {
    characters,
    isLoading: !data && !error,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
